export const somethingWentWrong = "Something Went Wrong.";
export const freeAccessWithPremium = "Free Access exclusive tools & insights";
export const feedEnd = "End of Feed";
export const noRecommendations = "No recommendations found.";
